import { PocButton } from 'commons/components/components-wrapper';
import { CustomWorkflowStep } from './custom-workflow-step.style';

export interface CustomWorkflowStepComponentProps extends React.PropsWithChildren {
    step: string;
    disabledChangeStep?: boolean;
    onChangeActionLabel?: string;
    onCancelActionLabel?: string;
    showFooter?: boolean;
    onChangeStep?: VoidFunction;
    onCancelStep?: VoidFunction;
}

export const CustomWorkflowStepComponent: React.FC<CustomWorkflowStepComponentProps> = (props) => {
    const {
        step,
        disabledChangeStep = false,
        onChangeActionLabel,
        onCancelActionLabel,
        showFooter = true,
        onChangeStep,
        onCancelStep,
        children,
    } = props;

    return (
        <CustomWorkflowStep key={step}>
            {children}
            {showFooter ? (
                <div slot="footer">
                    <PocButton
                        data-testid="custom-workflow-step-cancel"
                        key="cancel"
                        variant="secondary"
                        size="medium"
                        onClick={onCancelStep}
                    >
                        {onCancelActionLabel}
                    </PocButton>
                    <PocButton
                        data-testid="custom-workflow-step-change"
                        key="change"
                        variant="primary"
                        size="medium"
                        disabled={disabledChangeStep}
                        onClick={onChangeStep}
                    >
                        {onChangeActionLabel}
                    </PocButton>
                </div>
            ) : undefined}
        </CustomWorkflowStep>
    );
};
